import { Button } from 'shared-ui';

import { ReactComponent as ArchiveIcon } from 'assets/icons/archive-primary.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { ArchiveMultiGlcProps } from './ArchiveMultiGlc.types';

export const ArchiveMultiGlc = ({
  checkedGlc,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: ArchiveMultiGlcProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Button variant="outlined" color="primary" size="medium" startIcon={<ArchiveIcon />} onClick={onModalOpen}>
        {formatMessage({ id: AppMessages['glc.multiAction.archive.button'] })}
      </Button>

      <ActionModal
        header={formatMessage({ id: AppMessages['glc.multiAction.archive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['glc.multiAction.archive.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['glc.multiAction.archive.subtitle'] })} {checkedGlc.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['glc.multiAction.archive.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
